var map = {
	"./de-de.json": 6331,
	"./en-us.json": 5821,
	"./fi-fi.json": 4868,
	"./gr-gr.json": 7961,
	"./it-it.json": 9522,
	"./nl-nl.json": 9178,
	"./pl-pl.json": 8894,
	"./pt-pt.json": 1413,
	"./ro-ro.json": 7958,
	"./tr-tr.json": 6833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2528;